import { useState, useRef } from 'react'
import { useCanAccess } from '../../hooks/useCanAccess'
import { useBuildingStore } from '../../stores/buildingStore'
import { siteApi } from '../../services/siteApi'
import '../../styles/admin.css'

export default function IFCImportButton() {
  const canCreate = useCanAccess('sites', 'create')
  const fetchSites = useBuildingStore((s) => s.fetchSites)

  const [importing, setImporting] = useState(false)
  const [progress, setProgress] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState(false)
  const fileInputRef = useRef<HTMLInputElement>(null)

  if (!canCreate) return null

  const handleClick = () => {
    fileInputRef.current?.click()
  }

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (!file) return

    setImporting(true)
    setError(null)
    setSuccess(false)
    setProgress('Lecture du fichier...')

    try {
      const text = await file.text()
      setProgress('Validation du JSON...')

      // Validate JSON
      let parsed: unknown
      try {
        parsed = JSON.parse(text)
      } catch {
        throw new Error('Le fichier ne contient pas de JSON valide')
      }

      if (typeof parsed !== 'object' || parsed === null) {
        throw new Error('Le JSON doit etre un objet')
      }

      // Extract name from filename (remove .json extension)
      const name = file.name.replace(/\.json$/i, '')

      setProgress('Envoi au serveur...')
      await siteApi.importIFC(name, text)

      setProgress(null)
      setSuccess(true)
      await fetchSites()

      // Auto-clear success after 3s
      setTimeout(() => setSuccess(false), 3000)
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Erreur import IFC')
      setProgress(null)
    } finally {
      setImporting(false)
      // Reset file input
      if (fileInputRef.current) {
        fileInputRef.current.value = ''
      }
    }
  }

  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
      <input
        ref={fileInputRef}
        type="file"
        accept=".json"
        style={{ display: 'none' }}
        onChange={handleFileChange}
      />
      <button
        className="admin-btn admin-btn--create"
        onClick={handleClick}
        disabled={importing}
      >
        {importing ? 'Import...' : 'Import IFC'}
      </button>
      {progress && <span className="admin-loading">{progress}</span>}
      {error && <span style={{ color: '#ef4444', fontSize: 12 }}>{error}</span>}
      {success && <span style={{ color: '#4ade80', fontSize: 12 }}>Import reussi</span>}
    </div>
  )
}
